export const MainLayout = 'atlantis-main-layout';

export const HeaderContent = 'atlantis-header-content';
export const BodyContent = 'atlantis-body-content';
export const NavIconContainer = 'atlantis-nav-icon-container';
export const NavIcon = 'atlantis-nav-icon';
export const NavIconDropdown = 'atlantis-nav-icon-dropdown';
export const EnvironmentRibbon = 'atlantis-environment-ribbon';
export const SimpleLayout = 'atlantis-simple-layout';
